/**
 * THY AppFeedback entegrasyonunun yapılandırması (096).
 *
 * Entegrasyon **tek bir ortam parametresiyle** yönetilir: `VITE_APPFEEDBACK_BASE_URL`.
 * Değeri kullanılacak taban adresi belirler, **yokluğu entegrasyonu tamamen kapatır**.
 * Ayrı bir açık/kapalı bayrağı bilinçle yoktur — iki eksen olsaydı "adres var ama bayrak kapalı"
 * gibi tutarsız bir duruma düşülebilirdi.
 *
 * Alan adına bakarak (`*.thy.com` mı?) karar VERİLMEZ: domainler 25.08.2026'da bir kez zaten
 * değişti, tekrar değişirse entegrasyon sessizce ölürdü.
 */

/**
 * THY AppFeedback taban adresi. Boş string = entegrasyon kapalı.
 *
 * **`||` kullanılır, `??` DEĞİL.** docker-compose'un `${VAR:-}` geçişi, değişken hiç tanımlı
 * olmasa bile derlemeye **boş string** basabiliyor; `??` boş string'i "değer var" sayıp varsayılana
 * düşmüyor. Bu tam olarak 2026-08-15'te `VITE_API_URL` ile yaşandı — aynı hatayı tekrarlamamak için
 * depodaki yerleşik desene uyuluyor (bkz. `auth/oidcConfig.ts`, `api/client.ts`).
 *
 * Sondaki eğik çizgi(ler) ayrıca kırpılır: bileşen adresi yola doğrudan ekliyor, dolayısıyla
 * `https://…/` verilirse `…//api/Feedbacks/valid` oluşur. Bu da sessizce bozulur (bileşen 200
 * dışını yutuyor), üstelik değeri THY kendi derleme yapılandırmasında yazacağı için biz
 * göremeyiz.
 */
const baseUrl = (import.meta.env.VITE_APPFEEDBACK_BASE_URL || '').trim().replace(/\/+$/, '')

/**
 * THY'nin TK Seyir için tanımladığı senaryo kimliği.
 *
 * Künye — bu değerin neden koda gömülü olduğu:
 * - **Kaynak:** THY AppFeedback ekibi (analist teyidi, 2026-08-27).
 * - **Kapsam:** tek kimlik **iki senaryoyu birden** karşılar — Görev *oluşturma* ve Görev
 *   *tamamlama*. Kılavuzun genel kuralı her senaryoya ayrı kimlik verilmesidir; burası istisnadır.
 * - **Ortamlar:** test ve prod'da **aynı** kimlik kullanılır (THY teyidi).
 * - **Neden ortam parametresi değil:** ortama göre değişmiyor. Parametre yapmak, THY'nin kendi
 *   derleme yapılandırmasında doldurması gereken ve unutulduğunda entegrasyonu sessizce kapatan
 *   fazladan bir ayar noktası yaratırdı. THY kimliğin koda gömülmesine ayrıca izin verdi.
 * - **Sır değildir:** tarayıcıdan sorgu dizesinde açıkça gönderilir (bkz. contracts/appfeedback-http.md).
 *
 * THY ileride ortam başına ayrı kimlik verirse bu sabit ortam parametresine dönüşmelidir.
 */
export const APPFEEDBACK_SITE_ID = '51995e63-934c-42e7-8814-def0927a9823'

/** Entegrasyonun etkin olduğu ortamda kullanılacak taban adres. Kapalıyken boş string. */
export function appFeedbackBaseUrl(): string {
  return baseUrl
}

/**
 * Entegrasyon bu ortamda etkin mi?
 *
 * Tetikleme akışında **ilk ve en ucuz eleyici** budur: kapalıyken oturum okunmaz, belirteç
 * istenmez, dosya yüklenmez. THY dışı ortamlarda "hiçbir olumsuz etki hissedilmez" güvencesi
 * (US2) bu sıraya dayanır.
 */
export function isAppFeedbackEnabled(): boolean {
  return baseUrl.length > 0
}

/**
 * Uygulama bir THY alan adı altında mı çalışıyor?
 *
 * Yalnız **teşhis** amaçlıdır (FR-015) — entegrasyonun açılıp kapanmasında KULLANILMAZ.
 * Tek işi şu ayrımı yapabilmek: "bilinçli olarak kapalı" (RDC/lokal) ile "THY ortamındayız ama
 * derleme parametresi tanımlanmamış" (yapılandırma eksik). İkincisi başka türlü fark edilemez,
 * çünkü ikisi de dışarıdan "hiçbir şey olmuyor" gibi görünür.
 */
export function isThyOrigin(): boolean {
  return window.location.hostname.endsWith('.thy.com')
}
